export default "__VITE_ASSET__Cqxx7W37__"